/** Currency display shared by the site, the admin and the email templates. */

const SYMBOLS = {
  aud: "A$",
  nzd: "NZ$",
  sgd: "S$",
} satisfies Record<string, string>;

export function currencySymbol(currency: string): string {
  const key = currency.toLowerCase();
  return key === "aud" || key === "nzd" || key === "sgd" ? SYMBOLS[key] : "$";
}

/** Whole units drop the decimals ("S$2500"); fractional keep two ("A$12.50"). */
export function formatMoneyMinor(cents: number, currency: string): string {
  const major = cents / 100;
  const amount = Number.isInteger(major) ? String(major) : major.toFixed(2);
  return `${currencySymbol(currency)}${amount}`;
}
